import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
    fetchEnrollCourses,
    fetchTopicData,
    fetchUnitData
} from '../../Firebase/Course-fb';
import { sortData } from '../../Helper/Calculation';
import { useAccessCard } from '../../ContextProvider/Accesscardprovider';
import Datanotfound from '../../Helper/Datanotfound';
import {
    getUserDocId,
    isLoggedIn
} from '../../Localstorage';

const Topic = () => {
    // const location = useLocation();
    // const subject_code = location.state;
    const { topicId } = useParams()
    const navigate = useNavigate();

    const [isMobile, setIsMobile] = useState(false);
    const [loading, setLoading] = useState(true);
    const [filteredEnrollUnit, setFilteredEnrollUnit] = useState([]);
    const [topicFilter, setTopicFilter] = useState([]);
    const [enroll, setEnroll] = useState([]);

    // Fetch enrollment data
    useEffect(() => {
        const fetchEnrollment = async () => {
            if (isLoggedIn()) {
                try {
                    const userId = getUserDocId();
                    const enrolData = await fetchEnrollCourses(userId);
                    setEnroll(enrolData[0]?.course_list || []);
                } catch (error) {
                    console.error("Error fetching enrolled courses:", error);
                }
            }
        };

        fetchEnrollment();
    }, []);

    // Fetch unit data and topic list
    useEffect(() => {
        const fetchData = async () => {
            try {
                const filtered = enroll.find(
                    (item) => item.subject_code === topicId
                )?.unit_code_list || [];

                setFilteredEnrollUnit(filtered);

                const topic = await fetchUnitData(topicId);
                const topic_filter = sortData(topic.filter((t) => t.willShow === true));
                setTopicFilter(topic_filter);
            } catch (err) {
                console.error("Error fetching topic/unit data", err);
            } finally {
                setLoading(false);
            }
        };

        fetchData();

        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, [enroll, topicId]);

    // Navigation handler
    const handleToSubTopic = async (unit_code) => {
        const found = filteredEnrollUnit.includes(unit_code);
        const unit = await fetchTopicData(unit_code);
        const unit_filter = sortData(unit);
        navigate('/subTopic', { state: { unit_filter, found } });
    };

    // Loading state
    if (loading) {
        return (
            <div className='course_container'>
                <div className="loader">
                    Loading topics...
                    <div className="spinner" />
                </div>
            </div>
        );
    }

    // No data
    if (!topicFilter || topicFilter.length === 0) {
        return <Datanotfound />;
    }

    // Main UI
    return (
        <div className='course_container'>
            <h2>Units</h2>
            <div className='course_inner_container'>
                {topicFilter.map((item) => (
                    <div
                        key={item.unit_code}
                        className='course_card subject'
                        onClick={() => handleToSubTopic(item.unit_code)}
                    >
                        <img
                            className='course_card_img'
                            src={item.unit_image}
                            alt={item.unit_name}
                        />
                        <div
                            className={`heading sub ${item.unit_name.length > (isMobile ? 17 : 20)
                                ? 'long-text'
                                : ''
                                }`}
                        >
                            <span>{item.unit_name}</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Topic;
